export default "__VITE_ASSET__CcD7GkXr__"